import axios from "../axios"
import { AxiosResponse } from "axios"

export function queryLogs(params?: {}): Promise<AxiosResponse<any>> {
    return axios.get(`/logs`, {
        params: params
    })
}